import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'

const getBPLength = selectedData => {
  if (!selectedData) return 0
  const start = selectedData.ioBillingPeriodStartDate
  const end = selectedData.ioBillingPeriodEndDate
  return differenceInCalendarDays(end, start)
}

export default getBPLength
